var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[(_vm.isInit)?[_c('router-view')]:_vm._e(),_c('Login')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }